import React from "react";
import { CtaButton } from "../CtaButton";
import { insideStats } from "../../data/content";
export function SystemIntro() {
  return <section className="w-full bg-forestDark px-4 py-16 text-white sm:py-20" data-id="element-285" data-mp="fj1f6cp3cerz">
      <div className="mx-auto max-w-5xl" data-id="element-286" data-mp="ti9dl3dfjiv4">
        <div className="mx-auto max-w-3xl text-center" data-id="element-287" data-mp="tevd60obtjqb">
          <p className="mb-3 text-[13px] font-bold uppercase tracking-[0.14em] text-goldSoft" data-id="element-288" data-mp="oh3pjiupsjrx">Already organized for you</p>
          <h2 className="font-serif text-[30px] font-bold leading-[1.15] sm:text-5xl" data-id="element-289" data-mp="12g3bujur8mkx">
            From Scattered Notes to a <em className="text-goldSoft" data-id="element-290" data-mp="ye87t7lfvv3g">Clear, Step-by-Step</em> Learning Process
          </h2>
          <div className="mt-5 space-y-4 text-[17px] leading-relaxed text-white/85 sm:text-lg" data-id="element-291" data-mp="1c9ttp5wdlyrn">
            <p data-id="element-292" data-mp="17apmgkt0ib3y">
              Instead of spending hours creating your own study sheets, organizing scattered notes, or deciding what to review next,
              you'll have a structured collection of educational resources you can follow at your own pace.
            </p>
            <p data-id="element-293" data-mp="1vmnhnmkol30l">
              You'll receive structured learning pathways, educational checklists, concept maps, review worksheets, and a 30-day study roadmap.
            </p>
            <p className="font-semibold text-white" data-id="element-294" data-mp="24lr2ow3ershq">
              No complicated setup. No software to install. No need to design your own templates.
            </p>
          </div>
        </div>

        <h3 className="mt-12 text-center text-sm font-bold uppercase tracking-[0.14em] text-white/70" data-id="element-295" data-mp="2ekzvvmqg9331">What you get inside</h3>
        <dl className="mt-5 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4" data-id="element-296" data-mp="2jhzytos05ppx">
          {insideStats.map(s => <div key={s.label} className="rounded-2xl bg-white/[0.07] p-5 text-center ring-1 ring-white/10" data-id="element-297" data-mp="2oat3ydrdv02j">
              <dt className="sr-only" data-id="element-298" data-mp="2sdpf5jelftwg">{s.label}</dt>
              <dd data-id="element-299" data-mp="2xbr069vky3ak">
                <span className="block font-serif text-5xl font-bold text-goldSoft" data-id="element-300" data-mp="2xc95rx44ttv5">{s.value}</span>
                <span className="mt-2 block text-[14px] font-medium leading-snug text-white/85" data-id="element-301" data-mp="32aamwchzzj3z">{s.label}</span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-10" data-id="element-302" data-mp="x97z0vbv5nkc">
          <CtaButton label="Just download it and begin" data-id="element-303" data-mp="xa15rwatod2h" />
        </div>
      </div>
    </section>;
}